import React from 'react';
import backgroundImage from '../assets/image1.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAndroid, faApple } from '@fortawesome/free-brands-svg-icons';

const Downloads = () => {
  return (
    <div
      className="min-h-screen bg-cover bg-center p-4 flex flex-col justify-end"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div className="max-w-4xl mx-auto bg-black/80 rounded-lg p-8 backdrop-blur-sm w-full mb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Android Column */}
          <div className="text-center">
            <h2 className="text-white text-2xl font-bold mb-4">Android</h2>
            <p className="text-gray-400 mb-2">Latest Version:</p>
            <p className="text-white font-bold mb-6">2.2.4</p>
            <a
              href="https://play.google.com/store/apps/details?id=com.confesz.confeszapp"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex clickable items-center gap-2 bg-slate-600 hover:bg-slate-700 text-white font-bold py-2 px-8 rounded-lg transition-colors"
            >
              <FontAwesomeIcon icon={faAndroid} className="w-5 h-5" />
              Download
            </a>
          </div>

          {/* iOS Column */}
          <div className="text-center">
            <h2 className="text-white text-2xl font-bold mb-4">iOS</h2>
            <p className="text-gray-400 mb-2">Latest Version:</p>
            <p className="text-white font-bold mb-6">2.2.4</p>
            <a
              href="https://apps.apple.com/us/app/confesz/id6541248711"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex clickable items-center gap-2 bg-slate-600 hover:bg-slate-700 text-white font-bold py-2 px-8 rounded-lg transition-colors"
            >
              <FontAwesomeIcon icon={faApple} className="w-5 h-5" />
              Download
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Downloads;